import { db, IScanData } from './GateKeeperDb';

interface IScanHistoryFilter { 
    eventId?: string
}

class ScanHistory {

    protected _db = db;

    async addAsync(item: IScanData) {
        await this._db.scanHistory.add(item);
    }

    async listAsync(filter: IScanHistoryFilter) {

        let query : any = this._db.scanHistory;
        if (filter.eventId)
            query = query.where("eventId").equals(filter.eventId);
        const result = (await query.toArray()) as IScanData[];
        result.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
        return result;
    }

    async clearAsync(eventId?: string) {
        if (eventId)
            await this._db.scanHistory.where("eventId").equals(eventId).delete();
        else
            await this._db.scanHistory.clear();
    }

    async getLastScanAsync(eventId: string) {

        return (await this.listAsync({ eventId }))[0];

    }
}


export var scanHistory = new ScanHistory();